import { createSelectFilterChip } from 'components/filters/createSelectFilterChip';
import { formatOptionLabel } from 'modules/campaign/status/BlockStateField';
import { reportBlockStateOptions } from './Filter';

export const StateFilterChip = createSelectFilterChip(reportBlockStateOptions, {
  name: 'state',
  isMulti: true,
  defaultValueLabel: 'All states (except CANCELED)',
  formatOptionLabel,
});
